export const DEFAULT_THEME = {
  sidebarBg: '#c7dcef',
  sidebarBorder: '#a2c0dc',
  sidebarItemBg: '#e5edf6',
  sidebarItemHoverBg: '#d9e5f2',
  sidebarActiveBg: '#173f73',
  sidebarText: '#173f73',
  sidebarActiveText: '#ffffff',
  pageBg: '#f1f1ff',
  primary: '#173f73',
  primaryDark: '#0f2a4d',
  heading: '#163e72',
  buttonText: '#ffffff',
};

export const THEME_PRESETS = [
  {
    id: 'classic-blue',
    name: 'Classic Blue',
    values: { ...DEFAULT_THEME },
  },
  {
    id: 'emerald-care',
    name: 'Emerald Care',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#d2f0e5',
      sidebarBorder: '#9acdb6',
      sidebarItemBg: '#e7f7f0',
      sidebarItemHoverBg: '#d6f0e4',
      sidebarActiveBg: '#1f7a55',
      sidebarText: '#165842',
      primary: '#1f7a55',
      primaryDark: '#14543a',
      heading: '#14543a',
    },
  },
  {
    id: 'sunset-care',
    name: 'Sunset Care',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#ffe2d2',
      sidebarBorder: '#f3b896',
      sidebarItemBg: '#fff0e8',
      sidebarItemHoverBg: '#ffe6d8',
      sidebarActiveBg: '#b0542d',
      sidebarText: '#8c4122',
      primary: '#b0542d',
      primaryDark: '#7d3a1f',
      heading: '#7d3a1f',
    },
  },
  {
    id: 'royal-indigo',
    name: 'Royal Indigo',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#dcdffd',
      sidebarBorder: '#b8bff2',
      sidebarItemBg: '#ecefff',
      sidebarItemHoverBg: '#dfe3ff',
      sidebarActiveBg: '#3f4bb8',
      sidebarText: '#2e3891',
      primary: '#3f4bb8',
      primaryDark: '#2b347f',
      heading: '#2b347f',
    },
  },
  {
    id: 'teal-serenity',
    name: 'Teal Serenity',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#d5f2ee',
      sidebarBorder: '#9ad3c9',
      sidebarItemBg: '#e7f8f5',
      sidebarItemHoverBg: '#d7f1ec',
      sidebarActiveBg: '#1c7f74',
      sidebarText: '#175f57',
      primary: '#1c7f74',
      primaryDark: '#145a53',
      heading: '#145a53',
    },
  },
  {
    id: 'rose-clinic',
    name: 'Rose Clinic',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#ffe0ea',
      sidebarBorder: '#f1b3c8',
      sidebarItemBg: '#fff0f5',
      sidebarItemHoverBg: '#ffe5ee',
      sidebarActiveBg: '#b44571',
      sidebarText: '#8b3257',
      primary: '#b44571',
      primaryDark: '#7f2f50',
      heading: '#7f2f50',
    },
  },
  {
    id: 'graphite-pro',
    name: 'Graphite Pro',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#dde2ea',
      sidebarBorder: '#b6c0cf',
      sidebarItemBg: '#edf1f7',
      sidebarItemHoverBg: '#e1e7f1',
      sidebarActiveBg: '#3b4a60',
      sidebarText: '#2f3d52',
      primary: '#3b4a60',
      primaryDark: '#273243',
      heading: '#273243',
    },
  },
  {
    id: 'forest-mint',
    name: 'Forest Mint',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#dbefdf',
      sidebarBorder: '#a9d0b1',
      sidebarItemBg: '#ebf7ee',
      sidebarItemHoverBg: '#deefe3',
      sidebarActiveBg: '#2d7a3f',
      sidebarText: '#235f32',
      primary: '#2d7a3f',
      primaryDark: '#1e552b',
      heading: '#1e552b',
    },
  },
  {
    id: 'amber-glow',
    name: 'Amber Glow',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#ffeac7',
      sidebarBorder: '#f0ca85',
      sidebarItemBg: '#fff4df',
      sidebarItemHoverBg: '#ffecd0',
      sidebarActiveBg: '#b3771f',
      sidebarText: '#885b17',
      primary: '#b3771f',
      primaryDark: '#7e5315',
      heading: '#7e5315',
    },
  },
  {
    id: 'cool-sky',
    name: 'Cool Sky',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#d8ecff',
      sidebarBorder: '#a6cbed',
      sidebarItemBg: '#eaf5ff',
      sidebarItemHoverBg: '#dbeeff',
      sidebarActiveBg: '#2e79b8',
      sidebarText: '#225c8d',
      primary: '#2e79b8',
      primaryDark: '#20557f',
      heading: '#20557f',
    },
  },
  {
    id: 'mist-lavender',
    name: 'Mist Lavender',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#ebe8f6',
      sidebarBorder: '#cec6e4',
      sidebarItemBg: '#f5f3fb',
      sidebarItemHoverBg: '#e9e5f6',
      sidebarActiveBg: '#6a5f95',
      sidebarText: '#534a78',
      primary: '#6a5f95',
      primaryDark: '#4b436a',
      heading: '#4b436a',
    },
  },
  {
    id: 'powder-blue',
    name: 'Powder Blue',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#e4edf4',
      sidebarBorder: '#bfd0df',
      sidebarItemBg: '#f1f6fa',
      sidebarItemHoverBg: '#e4edf4',
      sidebarActiveBg: '#557a95',
      sidebarText: '#446276',
      primary: '#557a95',
      primaryDark: '#3c576a',
      heading: '#3c576a',
    },
  },
  {
    id: 'soft-sage',
    name: 'Soft Sage',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#e5eee6',
      sidebarBorder: '#bfd0c1',
      sidebarItemBg: '#f2f7f3',
      sidebarItemHoverBg: '#e4eee5',
      sidebarActiveBg: '#5c7b62',
      sidebarText: '#47604c',
      primary: '#5c7b62',
      primaryDark: '#405745',
      heading: '#405745',
    },
  },
  {
    id: 'warm-stone',
    name: 'Warm Stone',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#efe8df',
      sidebarBorder: '#d4c4af',
      sidebarItemBg: '#f8f4ef',
      sidebarItemHoverBg: '#eee6dd',
      sidebarActiveBg: '#7a6955',
      sidebarText: '#5f5243',
      primary: '#7a6955',
      primaryDark: '#554939',
      heading: '#554939',
    },
  },
  {
    id: 'calm-sea',
    name: 'Calm Sea',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#e1eff0',
      sidebarBorder: '#b6d0d2',
      sidebarItemBg: '#eff7f8',
      sidebarItemHoverBg: '#dfeeef',
      sidebarActiveBg: '#4e7f84',
      sidebarText: '#3e6468',
      primary: '#4e7f84',
      primaryDark: '#375b5f',
      heading: '#375b5f',
    },
  },
  {
    id: 'dusty-rose',
    name: 'Dusty Rose',
    values: {
      ...DEFAULT_THEME,
      sidebarBg: '#f1e6ea',
      sidebarBorder: '#d9c0c9',
      sidebarItemBg: '#f8f1f4',
      sidebarItemHoverBg: '#f0e3e8',
      sidebarActiveBg: '#8a5b69',
      sidebarText: '#6d4852',
      primary: '#8a5b69',
      primaryDark: '#613f49',
      heading: '#613f49',
    },
  },
];
